import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const fika: Collection = {
  id: 'ona-fika',
  brandId: 'ona',
  brandName: 'Ona',
  icon: 'ona.png',
  title: 'Fika',
  subTitle: 'Speels & kleurrijk',
  banner: 'fika/fika-banner.jpg',
  items: [
    {
      id: 'ona-fika-1',
      collectionImages: [
        {
          image: 'fika/fika-beige-roze-1.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'fika/fika-beige-roze-2.jpg',
          width: CollectionBannerWidth['50%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 'ona-fika-2',
      collectionImages: [
        {
          image: 'fika/fika.jpg',
          width: CollectionBannerWidth['100%'],
          fullHeight: true,
          items: []
        }
      ]
    }
  ],
  salesArticleIds: [
    '644df050-bb51-4cae-98dc-4f48d413faed',
    '8c8c3737-5d11-41f1-b70f-3a9c1b92c7cd',
    'b79d2147-6126-47d4-8f96-0b28cf09a7f7',
    '2617ac07-ee07-4e78-845a-496d2bc6c3ef',
    'b1517c59-bc4e-4f7a-89e1-05e4e5dacef3',
    '0f2a5ae7-6b4d-4a68-9854-db8d89329039',
    '956122b0-6f75-4b91-8e68-187eca0979d7',
    '6fd34c77-11eb-4283-9850-019c08aad614',
    '2a482f16-0c99-4692-874a-c730374d505f',
    '7b165749-76a5-45c0-9b67-b8c309beb6d7',
    'db81b6c4-e47b-44d5-8edb-bfc633d99472',
    '6cd8bbc0-b747-4ba6-b25c-7bab98889606'
  ]
};
